import { useState } from 'react';

const FAQS = [
  {
    q: 'Do I need marketing experience to use AI ads for local services?',
    a: 'Zero experience needed. AdForge is built for service business owners, not marketers. You answer a few plain-English questions about your service — your trade, your area, your offer — and the AI writes everything. No jargon, no learning curve.',
  },
  {
    q: 'What types of local service businesses can use AdForge?',
    a: 'AdForge works for virtually any local service business: plumbers, electricians, HVAC technicians, cleaners, pest control, movers, auto repair shops, tutors, pet groomers, lawn care, pressure washers, handymen, and more. If you serve local customers, AdForge is built for you.',
  },
  {
    q: 'How much does local service advertising with AdForge cost?',
    a: 'AdForge is free to start, no credit card required. Paid plans start at $29/month. Your actual Facebook or Google ad spend is separate and set by you directly in the ad platform.',
  },
  {
    q: 'How fast can I create local service ads with AdForge?',
    a: 'Most service business owners generate their first complete ad package — including copy, headlines, hooks, and up to 6 AI-generated images — in under 3 minutes. It\'s the fastest way to go from zero to a live local ad.',
  },
  {
    q: 'Can AdForge target my specific city or service area?',
    a: 'Yes. AdForge writes copy that\'s tailored to your specific service area. You tell it your city or region and the AI naturally incorporates local relevance into your ad copy. You then set the geographic targeting directly in Facebook Ads Manager or Google Ads.',
  },
  {
    q: 'Does AdForge create Google ads for local services too?',
    a: 'Yes. AdForge generates ad copy optimized for Facebook, Instagram, Google Ads, TikTok, and LinkedIn. You choose the platform and the AI formats everything correctly for it — including Google search ad headlines and descriptions.',
  },
  {
    q: 'Do I need a designer for the ad images?',
    a: 'No. AdForge generates up to 6 professional AI images per run, sized and formatted for your chosen platform. No designer, no stock photo subscription, no Canva required.',
  },
  {
    q: 'Is AdForge better than hiring a local marketing agency?',
    a: 'For most local service businesses, yes. Local marketing agencies charge $1,000–$4,000/month and take weeks to deliver. AdForge delivers a complete ad package in minutes for a fraction of the cost. You stay in control and can generate new ads for every promotion or season.',
  },
];

export default function LocalServicesFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            FAQ
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Questions About AI Ads for Local Services
          </h2>
          <p className="text-base text-stone-500">
            Everything you need to know about using AdForge for your local service advertising.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((faq, i) => (
            <div key={i} className="border border-stone-200 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-stone-50 transition-colors duration-200"
              >
                <h4 className="text-sm font-bold text-stone-900 leading-snug">
                  <a id={`faq-ls-${i}`}>{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIdx === i ? 'subtract' : 'add'}-line text-orange-500 text-lg`} />
                </div>
              </button>
              {openIdx === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-stone-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-stone-500">
            Still have questions?{' '}
            <a href="/contact" className="text-orange-500 font-semibold hover:underline">
              Contact our team →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
